export class CreateAccountModel {
  FirstName: string;
  LastName: string;
  CompanyName: string;
  Email: string;
  NewPassword: string;
  ConfirmPassword: string;
  Role: string;
  Id?: string;
  Code: string;
}
